import React from 'react'
//image
import logo from "./Images/logo.png";
import facebook from "./Images/facebook.png";
import linkdin from "./Images/linkdin.svg";
import insta from "./Images/insta.png";
import youtube from "./Images/youtube.svg";
import google from "./Images/google.svg";
import appstore from "./Images/appstore.svg";
import testway from "./Images/testway.svg";
import forWayTest from './Images/4-way-test.png';
import logo2 from "../Pages/Home/Images/logo.png";

// icon
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";

import { FaInstagramSquare } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaSquareYoutube } from "react-icons/fa6";

const Footer = () => {
  return (
    <div>
        <div className='bg-[#E5E5E5] px-[8%] flex flex-wrap items-center lg:flex-nowrap md:flex-wrap sm:flex-wrap w-100 py-[100px]'>
        <div className='lg:w-[100%] pt-1 md:w-[50%] sm:w-[90%] '>
          <a href="/"><img className="w-[120px] object-contain cursor-pointer	" src={logo2} alt="" /></a>
        <p className='font-[16px] text-slate-950 leading-5 text-justify  py-6
        '>You might say that you clean your solar panels regularly by yourself and that is enough. Although self-cleaning ensures dust cleaning but there is always a risk of damage and electric shock.</p>
        <div className='flex gap-x-4 z-20 text-[#29AAE1]'>
            <FaInstagramSquare className='w-6 h-6 cursor-pointer	'  onClick={()=>
              window.location.href="https://www.instagram.com/#/"
            }/>
            <FaFacebookSquare className='w-6 h-6 cursor-pointer	'  onClick={()=>
              window.location.href="https://www.facebook.com/#/"
            }/>
            <FaLinkedin className='w-6 h-6 cursor-pointer	'  onClick={()=>
              window.location.href="#"
            }/>
            <FaSquareYoutube className='w-6 h-6 cursor-pointer	'  onClick={()=>
              window.location.href="https://www.youtube.com/channel/#"
            }/>
        </div>
        
        </div>
        <div className='w-[100%] lg:pl-10 md:pl-0 md:w-[50%] md:mt-8 mt-8 lg:mt-0 sm:w-[100%] text-base'>
  
 
  <ul>
      <li className='flex items-center mt-4'>
     <span className=' text-[16px] text-slate-900 pl-2 cursor-pointer	 ' > <a href="/about"> About Us</a></span></li>
      <li className='flex items-center mt-4	'>
     <span className=' text-[16px] text-slate-900 pl-2  cursor-pointer	' > <a href="#" >Services</a> </span></li>
      
      <li className='flex items-center mt-4	'>
     <span className=' text-[16px] text-slate-900 pl-2 cursor-pointer	 ' > <a href="/members">Product</a> </span></li>

  </ul>
  </div>
        <div className='w-[100%] lg:pl-10 md:pl-0 md:w-[50%] md:mt-8 mt-8 lg:mt-0 sm:w-[100%]'>
  
       
        <ul>
            <li className='flex items-center mt-4'>
           <span className=' text-[16px] text-slate-900 pl-2 cursor-pointer	 ' > <a href="/about"> Terms & Conditions</a></span></li>
            <li className='flex items-center mt-4	'>
           <span className=' text-[16px] text-slate-900 pl-2  cursor-pointer	' > <a href="/contact">Privacy Policy</a> </span></li>
            
            <li className='flex items-center mt-4	'>
           <span className=' text-[16px] text-slate-900 pl-2 cursor-pointer	 ' > <a href="/members">Contacts</a> </span></li>
      
         
        </ul>
        </div>
        <div className='w-[100%] flex flex-col   md:mt-8 mt-8 lg:mt-0 sm:w-[100%] md: items-start'>
        {/* <h5 className='m-0 text-[20px] text-[#CBD5E0] font-semibold leading-5 pl-2 pb-2 mr-8'>App Download</h5> */}
        {/* <div className='h-[1.5px] bg-[#FDBC12] w-[155px] mr-6 mt-2'></div> */}
        <ul>
            <li className='flex items-center mt-3 	'> <FaPhoneAlt className='text-[16px] text-[#29AAE1] cursor-pointer'/>
           <span className=' text-[16px] text-slate-900] pl-2  cursor-pointer	 ' > +91 9509933959</span></li>
            
             
            <li className='flex items-center mt-3 	'> <FaEnvelope className='text-[16px] text-[#29AAE1] cursor-pointer	' />
           <span className=' text-[16px] text-slate-900 pl-2  cursor-pointer	' >info@ensolsolutions.com</span></li>
           <li className='flex items-center mt-3 	'> <IoLocationSharp className='text-[30px] text-[#29AAE1] cursor-pointer	' />
           <span className=' text-[16px] text-slate-900 pl-2 pr-2 cursor-pointer	' > 3rd FLOOR ANSUYA APPARTMENT, Hujarat Paga Rd, Karelibagh, Vadodara, Gujarat 390006</span></li>
        </ul>
        </div>
        </div>
        
    </div>
  )
}

export default Footer